<template>
	<Service class="honano">
		<h2>Services</h2>

		<p class="year">2020</p>

		<h3>
			honano<span class="subtitle">みんなの「またね」を届ける</span>
		</h3>
		<section class="logo content-box">
			<h4>Logo</h4>
			<img src="images/service/honano/logo.png" />
            <p>ネーミングは、福井弁で「またね」の意味。優しいイメージで、アースカラーの淡い色を使用。</p>
		</section>

	
		<section class="solution content-box">
			<h4>Story</h4>
			<h5>大切な仲間へおくるメッセージ。</h5>
			<p>
				身近な、大切な仲間が自分たちから旅立つ。卒業・転校・転職・転勤のときに、お礼や思い出を贈りたい。そんなときには寄せ書きをする。寄せ書きアプリ、サービスってなかなか思ったようなものがない。手軽さもない。じゃあ作ってしまおう！
			</p>
			<h5>コンセプトは、手軽さ。みんなでおくる「またね」</h5>
			<p>
                2019年に、一人の人のためにWebサービスとして、退職日に間に合わそうということで企画、デザイン、開発までを4人であつまり約1カ月で制作。一人のためじゃなく、みんなで使えるものを作ると、どうなるのか？という案から、LINEの機能をいかせば利用者の多いLINEでみんなに寄せ書きをつのりやすいという考えのもとLINEを使った寄せ書きサービスを再開発。
			</p>
            <h5>LINEのグループ、bot、LIFFなどを活用した寄せ書き。</h5>
             <p>LINEグループに、honanoのbotを招待。新規で投稿するリンクが会話形式で表示されるので、そこをひらいて自分の投稿をおこないます。他の人の投稿もプレビューでみれます。最初に設定した人が管理者になり、名前の変更や、期限を設定して自動でリマインドできます。
            </p>
		</section>
		
		<section class="web-design">
			<h4>Design</h4>

			<img src="images/service/honano/screen.png" />
		</section>
	</Service>
</template>

<style lang="scss" scoped>
.honano {
	.top {
		img {
			width: 600px;
			margin: 0 auto;
		}
	}

	.logo {
		> img {
			width: 275px;
			margin-bottom: 30px;
		}

		p {
			width: 320px;
			margin: 0 auto;
		}
	}

	.about-service {
		width: 768px;
	}

	.target {
		> p {
			text-align: center;
		}
	}
	.service p.url{
		text-align: center;
	}
}


</style>

<script>
import Service from "@/components/Service.vue";

export default {
	components: {
		Service
	}
};
</script>
